import * as React from 'react';

type ContextState = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const PageHeaderForFiltersContext = React.createContext<ContextState>({} as ContextState);